import RightChevronIcon from "@/assets/colorable/right_chevron.svg?react";
import UserPlusIcon from "@/assets/colorable/user_plus.svg?react";
import AnimatedAccordion from "@/components/Common/animated/AnimatedAccordion";
import Toggle from "@/components/Common/forms/Toggle";
import HighlightedHTMLTextArea from "@/components/Common/HighlightedHTMLTextArea";
import clsxm from "@/lib/clsxm";
import {useState, type FC} from "react";
import {useTranslation} from "react-i18next";

const ReferralSignupForm: FC<{slug?: string | null}> = ({slug}) => {
  const {t} = useTranslation("referral");
  const [shouldShowHeader, setShowHeader] = useState(false);
  const [isOpen, setOpen] = useState(false);

  const html = `<!-- Influencer signup form -->
<div id="refluenced-referral-form" data-slug="${slug}"${shouldShowHeader ? ` data-header="true"` : ""}></div>
<script src="${window.location.origin}/referral/referral-form.js"></script>
  `
    .split("\n")
    .filter(line => line.trim() !== "")
    .join("\n");

  const previewLink = `${window.location.origin}/embed/join/${slug}${shouldShowHeader ? "?header=true" : ""}`;

  return (
    <div className="flex flex-col">
      <div
        className={clsxm(
          "bg-neutral-grey-lightest flex cursor-pointer items-center justify-between rounded-lg p-3 pr-5 transition-all",
          isOpen && "rounded-b-none",
        )}
        onClick={() => setOpen(value => !value)}>
        <div className="flex items-center gap-3.5">
          <div className="flex size-10 items-center justify-center rounded-md bg-white">
            <UserPlusIcon className="text-primary-dark-solid size-3.5 shrink-0" />
          </div>
          <div className="flex flex-col gap-2">
            <span className="text-neutral-black text-sm leading-2.5 font-semibold">{t("website_signup_form")}</span>
            <span className="text-neutral-slate-grey text-2xs leading-3">
              {t("website_signup_form_short_description")}
            </span>
          </div>
        </div>
        <RightChevronIcon
          className={clsxm("text-neutral-black size-3 transition-all", isOpen ? "-rotate-90" : "rotate-90")}
        />
      </div>
      <AnimatedAccordion condition={isOpen}>
        <div className="bg-neutral-grey-lightest border-t-neutral-grey-light-dark flex flex-col gap-5 border-t px-8 py-3">
          <div className="text-neutral-black flex flex-col gap-5 text-xs sm:flex-row">
            <div className="flex items-center gap-2.5">
              <Toggle checked={shouldShowHeader} onChange={setShowHeader} />
              <span>{t("show_brand_logo")}</span>
            </div>
          </div>
          <div className="max-w-[calc(100vw-64px)]">
            <HighlightedHTMLTextArea code={html} previewLink={previewLink} />
          </div>
        </div>
      </AnimatedAccordion>
    </div>
  );
};

export default ReferralSignupForm;
